import axios from 'axios';



export const apiClient = axios.create({
    baseURL: `${import.meta.env.VITE_API_URL}/api/v1`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add response interceptor for better error handling
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', {
            url: error.config?.url,
            method: error.config?.method,
            status: error.response?.status,
            message: error.message,
            data: error.response?.data
        });
        return Promise.reject(error);
    }
);

// Types pour les données d'onboarding
export interface OnboardingItem {
    id: string;
    tag: string;
    title: string;
    file_url: string;
    file_type: 'image' | 'video';
    description?: string;
    sort_order: number;
    is_active: boolean;
    language_code: string;
    created_at: string;
    updated_at: string;
}

// Fonctions API pour l'onboarding
export const onboardingAPI = {
    // Récupérer tous les items d'onboarding actifs
    getActiveItems: async (languageCode?: string): Promise<OnboardingItem[]> => {
        try {
            const params: any = { active: true };
            if (languageCode) {
                params.lang = languageCode;
            }

            const response = await apiClient.get('/onboarding', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching onboarding items:', error);
            return [];
        }
    },
};

export default apiClient;
